"use strict";
/**
 * A {@code Ray} is made up of a starting point and an ending point.
 *
 * @param <T> Type of vector, either 2D or 3D, implementing the {@link Vector} interface
 *
 * @author davebaol
 */
var Ray = (function () {
    /**
     * Creates a {@code Ray} with the given {@code start} and {@code end} points.
     * @param start the starting point of this ray
     * @param end the starting point of this ray
     */
    function Ray(start, end) {
        this.start = start;
        this.end = end;
    }
    /**
     * Sets this ray from the given ray.
     * @param ray The ray
     * @return this ray for chaining.
     */
    Ray.prototype.copy = function (ray) {
        this.start.copy(ray.start);
        this.end.copy(ray.end);
        return this;
    };
    /**
     * Sets this Ray from the given start and end points.
     * @param start the starting point of this ray
     * @param end the starting point of this ray
     * @return this ray for chaining.
     */
    Ray.prototype.set = function (start, end) {
        this.start.copy(start);
        this.end.copy(end);
        return this;
    };
    return Ray;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Ray;
//# sourceMappingURL=Ray.js.map


/*****************
 ** WEBPACK FOOTER
 ** /Users/songseunggeun/pawsong/gdx-ai.js/lib/utils/Ray.js
 ** module id = 902
 ** module chunks = 0
 **/